<div class="content-wrapper">
	<div class="content-wrapper">
		<div class="content-body">

			<!-- content-header component -->
			<app-content-header [contentHeader]="contentHeader"></app-content-header>

			<div class="card">

				<!-- TABELA DE DADOS -->
				<section id="ngx-datatable-inline-editing">
					<!-- FUNCOES DA TABELA -->
					<div class="row">
						<div class="col-12">
							<button class="btn btn-primary float-right mr-1 mt-1" routerLink="/sistema/cadastro"
								rippleEffect>
								<i data-feather="plus" class="mr-0 mr-sm-1"></i><span
									class="d-none d-sm-inline-block">Adicionar</span>
							</button>
							<!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
                                        CSV</a> -->
						</div>
					</div>
					<hr>
					<!-- FILTROS DA TABELA -->
					<div class="row">
						<div class="col-md-6 col-12">
							<div class="d-flex justify-content-between align-items-center m-1">
								<label class="d-flex align-items-center">Mostrar
									<select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
										<option value="100">100</option>
									</select>
								</label>
							</div>
						</div>
					</div>

					<!-- DATATABLE -->
					<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
						[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
						[loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="false">

						<!-- COLUNA -->
						<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Nome</h4>
								<input type="search" placeholder="Pesquisar Nome" class="ml-25 form-control"
									(keyup)="nomeFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.nome | uppercase}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA -->
						<ngx-datatable-column name="Status" prop="status" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Status</h4>
								<input type="search" placeholder="Pesquisar Status" class="ml-25 form-control"
									(keyup)="statusFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="badge badge-pill" [ngClass]="{
									'badge-light-danger': row.status == 1,
									'badge-light-success': row.status == 0
								  }">{{getNomeStatus(row.status)}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA -->
						<ngx-datatable-column [width]="20" [sortable]="false">
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<div class="d-flex align-items-center" style="float: right">
									<div ngbDropdown container="body">
										<a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
											id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
											aria-expanded="false">
											<i data-feather="more-vertical"
												class="text-primary cursor-pointer mr-50"></i>
										</a>
										<div ngbDropdownMenu class="dropdown-menu-right"
											aria-labelledby="dropdownBrowserState">
											<a routerLink="/sistema/editar/{{row.id_sistema}}" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="file-text"
													class="mr-50"></i> Editar</a>
											<a (click)="msgConfirmacao(row.id_sistema)" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="trash-2"
													class="mr-50"></i> Excluir</a>
										</div>
									</div>
								</div>
							</ng-template>
						</ngx-datatable-column>

					</ngx-datatable>
				</section>

			</div>
		</div>
	</div>